<template>
  <div class="mx-1">
    <div>
      <div class="data-name">{{ value.description | empty }}</div>
    </div>
    <validation-observer :ref="`answers-${value.id}`">
      <div class="my-3">
        <div v-for="item in groupedOptions" :key="item.key">
          <validation-provider
            v-slot="{ errors }"
            :name="`answers-${item.key}-checks`"
            rules="checks"
          >
            <options-panel
              v-model="item.options"
              :data="{ options: item?.options || [] }"
              :has-container-panel="false"
              is-other-large
              :is-read-only="isReadOnly"
              is-vertical
              option-col="col-3 py-3"
              :show-header="false"
            />
            <error
              v-if="errors[0]"
              class="mt-3"
              message="Seleccione al menos una opción"
              variant="no-border"
            />
          </validation-provider>
          <hr v-if="item.key < groupedOptions.length" />
        </div>
      </div>
      <div v-for="otherItem in others" :key="otherItem.id" class="my-3">
        <label class="data-name">{{ otherItem.name }}:</label>
        <p v-if="isReadOnly">{{ otherItem.other | empty }}</p>
        <validation-provider
          v-else
          v-slot="{ errors }"
          :name="`answers-${value.id}-${otherItem.id}-comment`"
          rules="required"
        >
          <custom-text-area
            v-model="otherItem.other"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
            :maxlength="5000"
            show-char-count
          />
        </validation-provider>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';
import Error from 'custom-error';
import OptionsPanel from '../../../../../components/OptionsPanel.vue';

import { extend } from 'vee-validate';
extend('checks', {
  validate: (value) => value?.some((x) => x.checked),
});

export default {
  name: 'AreaItem',
  components: {
    ValidationProvider,
    CustomTextArea,
    Error,
    OptionsPanel,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    groupedOptions() {
      const options = (this.model.options ?? []).filter((x) => !x.isOther);
      const grouped = options.reduce((acc, item) => {
        (acc[item.group] ??= []).push(item);
        return acc;
      }, {});
      return Object.entries(grouped).map(([key, value]) => ({
        key,
        options: value,
      }));
    },
    others() {
      return this.model.options?.filter((x) => x.isOther) ?? [];
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
::v-deep .options-vertical {
  background-color: #f7f7f7 !important;
  padding: 0px !important;
}
</style>
